import React from 'react';
// import axios from 'axios';
import reqwest from 'reqwest';
import {Button, Spin, Input, Tooltip, message, Alert,} from 'antd';
// import components
import CompletionUpdate from './views/CompletionUpdate';
import FileListTable from './views/FileListTable';
// import styling
import './index.css';


function validateSessionID(id){
  let _id = id.trim();
  if(_id === null || _id === "" || _id.length !== 32){
    return false;
  }else{
    return true;
  }
}

class TrackSession extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      completion: [],
      progress: [
        ['Spectra clustering complete', 0,], 
        ['Database construction complete', 0],
        ['Peptides identification complete', 0],
        ['Taxonomy analysis & function annotation complete', 0],
      ],
      loading: false,
      sessIDValidated: false,
      sessIdValidationMsg: null,
      sessionID: "",
      resultsUpdate: "No results available",
      resultFiles: [],
      output: [],
      reportReady: false
    }
  }

  updateSessionID = (e) => {
    // console.log(e.target.value);
    this.setState({sessionID: e.target.value.trim()});
  }

  refreshProgress=(url)=>{
    // console.log(requestUrl);
    let completionUpdate = [];
    let progressUpdate = [];

    //valide session ID entry using js
    
    if(validateSessionID(this.state.sessionID)){
      this.setState({
        loading: true,
        completion: [],
        progress: [
          ['Spectra cluster complete', 0,], 
          ['Database construction complete', 0],
          ['Peptides identification complete', 0],
          ['Taxonomy analysis complete', 0],
        ],
        resultsUpdate: "No results available",
        resultFiles: [],
        reportReady: false
      });

      reqwest({
        url: url,
        method: 'post',
        crossOrigin: true,
        data: {sess_id: this.state.sessionID},
        success: (_data) => {
          // console.log(_data);
          // let data = [];
          let data = JSON.parse(_data);
          //console.log(data);

          this.setState({
            sessIdValidationMsg: null,
            loading: false,
          });

          if(data.update !== ""){
      
            if(data.update === "complete"){
              //console.log("step four completed");
              completionUpdate = ['Step one complete', 'Step two complete', 'Step three complete', 'Step four complete', 'Data processing complete'];
              progressUpdate = [
                  ['Spectra cluster complete', 100, ], 
                  ['Database construction complete', 100],
                  ['Peptides identification complete', 100],
                  ['Taxonomy analysis complete', 100],
              ];
              this.setState({
                  resultsUpdate: "Complete",
                  resultFiles: data.files,
                  reportReady: true,
                  output: data.out
              });
            }else if(data.update === "three"){
                //console.log("step three completed");
                completionUpdate = ['Step one complete', 'Step two complete', 'Step three complete',];
                progressUpdate = [
                    ['Spectra cluster complete', 100, ], 
                    ['Database construction complete', 100],
                    ['Peptides identification complete', 100],
                    ['Taxonomy analysis complete', 0],
                ];
                this.setState({
                  resultsUpdate: "Collecting data...",
                  resultFiles: data.files,
                  output: data.out
                });
            }else if(data.update === "two"){
                //console.log("step two completed");
                completionUpdate = ['Step one complete', 'Step two complete',];
                progressUpdate = [
                    ['Spectra cluster complete', 100, ], 
                    ['Database construction complete', 100],
                    ['Peptides identification complete', 0],
                    ['Taxonomy analysis complete', 0],
                ];
                this.setState({
                  resultsUpdate: "Collecting data...",
                  resultFiles: data.files,
                  output: data.out
                });
            }else if(data.update === "one"){
                //console.log('step one completed');
                completionUpdate = ['Step one complete',];
                progressUpdate = [
                    ['Spectra cluster complete', 100, ], 
                    ['Database construction complete', 0],
                    ['Peptides identification complete', 0],
                    ['Taxonomy analysis complete', 0],
                ];
                this.setState({
                  resultsUpdate: "Collecting data...",
                  resultFiles: data.files,
                  output: data.out
                });
            }else{
              console.log('No data available yet...');
              completionUpdate = [];
              progressUpdate = [
                  ['Spectra cluster complete', 0, ], 
                  ['Database construction complete', 0],
                  ['Peptides identification complete', 0],
                  ['Taxonomy analysis complete', 0],
              ];
              this.setState({
                resultsUpdate: "Initiating data processing...",
                output: data.out
              });
            }
            
            this.setState({completion: completionUpdate, progress: progressUpdate, });
            message.success('progress data updated successfully.');

          }else if(data.error !== ""){
              //console.log("error: " + data.error);
          }else{
              //console.log("error: unkown error...");
          } 
        },
        error: (error) => {
          //console.log(error);
          this.setState({
            loading: false,
            sessionID: ""
          });
          message.error('Connecting to iMetaLab server failed, unable to load progress data.');
        },
      });
      // this.setState({sessionID: ""});
    }else{
      this.setState({
        loading: false,
        sessIdValidationMsg: "invalid session ID.",
        resultsUpdate: "No results available",
        sessionID: ""
      })
    }
  }

  render(){
      //console.log(this.props);
      const {sessionID, completion, progress, resultsUpdate, resultFiles, reportReady, sessIdValidationMsg, loading} = this.state;
      const {SERVER_APIS} = this.props;
      return (
        <div className="track-session-outter-wrapper">
          <div className="track-session-inner-wrapper">
            <section className="track-session-enterID-section">
              <Tooltip title="Enter your session ID here">
                <Input placeholder="metasess_5982077a2bf951.10052915"
                  value={sessionID}
                  onChange={this.updateSessionID}/>
              </Tooltip>
              <Button 
                style={{width: 'auto', marginLeft: '10px'}}
                type="primary"
                icon="reload" 
                onClick={()=>this.refreshProgress(`${SERVER_APIS.SERVER_URL}${SERVER_APIS.UPDATE_SESSION}`)}>
                Track Your Session
              </Button>
            </section>
            {
              sessIdValidationMsg
              &&
              <Alert description={sessIdValidationMsg} type="error" style={{margin: 20, width: '60%', }}/>
            }
            <section className="track-session-completion-section">
              <Spin 
                tip="Connecting to iMetaLab server..." 
                spinning={loading}>
                <CompletionUpdate 
                  steps={completion}
                  progress={progress}
                  resultsUpdate={resultsUpdate}
                  resultFiles={resultFiles}
                  id={sessionID} 
                  url={`${SERVER_APIS.SERVER_URL}${SERVER_APIS.UPDATE_SESSION}`}>
                </CompletionUpdate>
              </Spin>
            </section>

            <section className="track-session-log-section">
            <Spin 
                tip="Connecting to iMetaLab server..." 
                spinning={loading}>
                <h3>Session Log</h3>
                <div className="track-session-log-container">
                 {
                   this.state.output.map((item)=>{
                     return (
                      <p>{item}</p>
                     )
                   })
                 }
               </div>
              </Spin>
            </section>

            <section className="track-session-filelist-section">
              <FileListTable 
                resultFiles={resultFiles}
                reportReady={reportReady}
                id={sessionID} 
                download_file={`${SERVER_APIS.SERVER_URL}${SERVER_APIS.DOWNLOAD_FILE}`}
                download_all={`${SERVER_APIS.SERVER_URL}${SERVER_APIS.DOWNLOAD_ZIP}`}
                download_selection={`${SERVER_APIS.SERVER_URL}${SERVER_APIS.DOWNLOAD_SELECTED}`}
                download_result={`${SERVER_APIS.SERVER_URL}${SERVER_APIS.DOWNLOAD_RESULT}`}
                download_report={`${SERVER_APIS.SERVER_URL}${SERVER_APIS.DOWNLOAD_REPORT}`}
                download_taxonomy={`${SERVER_APIS.SERVER_URL}${SERVER_APIS.DOWNLOAD_TAXONOMY}`}
                download_function={`${SERVER_APIS.SERVER_URL}${SERVER_APIS.DOWNLOAD_FUNCTION}`}
                view_report={`${SERVER_APIS.SERVER_URL}${SERVER_APIS.VIEW_REPORT}`}
              />
            </section>
          </div>
      </div>
      );
  }
}

TrackSession.defaultProps={
  
}

export default TrackSession;